<app-breadcrumb></app-breadcrumb>

<section class="mainContent">
  <div class="container">
    <div class="row">
      <div class="col-3">
        <input type="text" class="form-control" [(ngModel)]="filters.filename" (ngModelChange)="onModelChange($event)"
          placeholder="Filter by Image File Name"><br />
        </div>
        <div class="col-9 filters">
          <button type="button" class="btn btn-outline-primary" (click)="filterStatus('all')">Show All <i class="fas"
          [ngClass]="{'fa-square-check': filters.status === 'all', 'fa-square': filters.status !== 'all'}"></i></button>
          <button type="button" class="btn btn-outline-primary" (click)="filterStatus('Used')">Used <i class="fas"
          [ngClass]="{'fa-square-check': filters.status === 'Used', 'fa-square': filters.status !== 'Used'}"></i></button>
          <button type="button" class="btn btn-outline-primary" (click)="filterStatus('Not Used')">Not Used <i class="fas"
          [ngClass]="{'fa-square-check': filters.status === 'Not Used', 'fa-square': filters.status !== 'Not Used'}"></i></button>
        </div>
      </div>
      @if (imageListService.imagelist$ | async; as imageList) {
        <div class="row fade-in">
          <div class="col-6 offset-sm-6">
            <label class="label-right">Total: {{imageList.metadata.totalCount}}</label>
            <nav>
              <ngb-pagination class="d-flex justify-content-end" [collectionSize]="imageList.metadata.totalCount"
                [(page)]="filters.page" [pageSize]="imageList.metadata.pageSize" (pageChange)="goToPage($event)"
                [maxSize]="4" [rotate]="true" [boundaryLinks]="true">
            </ngb-pagination>
          </nav>
        </div>
      </div>
    }

    <ng-template #stockItemsLoading>
      <div class="row loading">
        <div style="width: 100%"><i class="fas fa-spinner fa-5x fa-spin"></i></div>
      </div>
    </ng-template>

    @if (imageListService.imagelist$ | async; as imageList) {
      <div class="row fade-in">
        <div class="col-12">
          <div class="table-responsive">
            <form #imageListForm="ngForm">
              <div class="row">
                <div class="col-9">
                  <h1>Images</h1>
                </div>
              </div>
              @if (imageListService.images$ | async; as images) {
                <div class="row image-results fade-in">
                  @if (images.result.length > 0) {
                    @for (image of images.result; track image) {
                      <div class="col-md-3">
                        <span class="stockCode"><b>{{image.fileName}}</b></span><br />
                        <span class="stockImage"><img [src]="image.safeImageUrl"
                        (click)="linkImageToItem(image, stockItem); myDrop.close()" class="img-thumbnail"></span>
                      </div>
                    }
                  } @else {
                    <div class="row not-found-message">
                      <p>Matching images not found</p>
                    </div>
                  }
                </div>
              } @else {
                <ng-template [ngTemplateOutlet]="imagesLoading"></ng-template>
              }
            </form>
          </div>
        </div>
      </div>
    }

    @if (imageListService.imagelist$ | async; as imageList) {
      <div class="row fade-in">
        <div class="col-sm-6 offset-sm-6">
          <label class="label-right">Total: {{imageList.metadata.totalCount}}</label>
          <nav>
            <ngb-pagination class="d-flex justify-content-end" [collectionSize]="imageList.metadata.totalCount"
              [(page)]="filters.page" [pageSize]="imageList.metadata.pageSize" (pageChange)="goToPage($event)"
              [maxSize]="4" [rotate]="true" [boundaryLinks]="true">
            </ngb-pagination>
          </nav>
        </div>
      </div>
    }
  </div>
</section>